import { render, staticRenderFns } from "./EditAlertStep.vue?vue&type=template&id=084e9f7e&scoped=true&"
import script from "./EditAlertStep.vue?vue&type=script&lang=js&"
export * from "./EditAlertStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084e9f7e",
  null
  
)

export default component.exports